/**
 * Created by shikha on 05/05/2021.
 */

export class HHTranslationStrings {
    public static M1quote0: string = "There are no heroes or villains. There's just what I want and how I'll get it.";
    public static M1quote1: string = "Maybe I am a villain in your story, but I am a hero in mine.";
    public static M1quote2: string = "If you're good at something, never do it for free.";

    public static M2quote0: string = "Some people just want to watch the world burn!";
    public static M2quote1: string = "Let's put some light into the shadows.";

    public static M3quote0: string = "You either die a hero or live long enough to see yourself become the villain.";
    public static M3quote1: string = "Life's a bitch, and so am I.";
    public static M3quote2: string = "Always confusing your pistols with your privates.";

    public static M4quote0: string = "Madness is like gravity - all it takes is a little push.";
    public static M4quote1: string = "Live as a villain, die as a hero";

    public static M5quote0: string = "You break my trust, I break your bones - as simple as that.";
    public static M5quote1: string = "SMASH!";
}